import { StoreDetailsModel } from "../stores/@types/storeDetails.model";

export const $PreferredStoreModuleName = "preferredStore";

export type TGetPreferredStoreByCodeRequest = {
    code: string;
    sku: string;
    includeProductAvailability?: boolean;
};

export type TPreferredStoreState = StoreDetailsModel;
